/***** Web Developer Custom Script *****/

jQuery(document).ready(function($) {
  
  /* Testimonial slider function */
  if ( $('#home_testimonials').length ) {
    $('#home_testimonials').slick({
      dots: true,
      arrows: false,
      autoplay: true,
  	  autoplaySpeed: 3000,
      infinite: true,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1399,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }
  
  
  /* Video Play/Pause control function */
  $('.video_wrapper').hover(
    function() {
      if ( !$(this).hasClass('youtube_wrapper') ) {
        var video = $(this).find('.intro_video').get(0);
        if ( video.paused ) {
          $(this).find('.video_play').show();
        } else {
          $(this).find('.video_pause').show();
        }
      }
    }, function() {
      if ( !$(this).hasClass('youtube_wrapper') ) {
        var video = $(this).find('.intro_video').get(0);
        if ( video.paused ) {
          $(this).find('.video_play').show();
        } else {
          $(this).find('.video_pause').hide();
        }
      }
    }
  );
  
  $('.video_btn').on('click', function() {
    
    var video = $(this).siblings('.intro_video').get(0);
    if ( $(this).hasClass('video_play') ) {
      video.play();
      $(this).hide();
    } else {
      video.pause();
      $(this).hide();
    }
  
  });
  
  $('.intro_video').on('ended', function() { 
  	$(this).siblings('.video_play').show();
  });
  
  if( /Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    
    $('.intro_video').on('click', function() {
    
      var video = $(this).get(0);
      if ( video.paused ) {
        video.play();
        $(this).siblings('.video_play').hide();
      } else {
        video.pause();
      }

    });
    
  }
  
  
  /* FAQ Block Collapase/Expand function */
  $('.faq_block').on('click', function() {
    
    $('.faq_block').not(this).find('p').slideUp( 'fast', function() {
    });
    $('.faq_block').not(this).removeClass('expanded');
    if ( $(this).hasClass('expanded') ) {
      $(this).find('p').slideUp( 'fast', function() {
      });
      $(this).removeClass('expanded');
    } else {
      $(this).find('p').slideDown( 500, function() {
      });
      $(this).addClass('expanded');
    }
  
  });
  
  
  /* Page to Top function */
  if ( $(window).scrollTop() > 450 ) {
    $('#page_top').addClass('active');
  } else {
    $('#page_top').removeClass('active');
  }
  
  $(window).scroll(function() {
    
    if ( $(window).scrollTop() > 450 ) {
      $('#page_top').addClass('active');
    } else {
      $('#page_top').removeClass('active');
    }
    
  });
  
  $('#page_top').on('click', function(e) {

    $('html, body').animate({ 
      scrollTop: '0' 
    }, 600); 

  });
  
  
  /* Overview logo slider function */
  if ( $('.overview_logo_wrapper').length ) {
    $('.overview_logo_wrapper').slick({
      dots: false,
      arrows: false,
      autoplay: true,
  	  autoplaySpeed: 2000,
      infinite: true,
      speed: 500,
      slidesToShow: 6,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  }
  
  
  /* Overview Printer Comment function */
  if ( $(window).width() > 1024 ) {
    
    $('.printer_sign').hover(
      function() {
        $(this).siblings('.printer_comment').show();
      }, function() {
        $(this).siblings('.printer_comment').hide();
      }
    );
    
  } else {
    
    $('.printer_sign').on('click', function() {
      $('.printer_comment').not($(this).siblings('.printer_comment')).hide();
      $(this).siblings('.printer_comment').show();
    });
    
    $('body').on('click', function(e) {
      if ( $(e.target).hasClass('printer_sign') || $(e.target).hasClass('printer_comment') ) {
        return;
      } else {
        $('.printer_comment').hide();
      }
	});
    
  }
  
  
  /* Compare Menu list click function */
  $('.compare_active_wrapper').on('click', function() {
    
    var tag_num = '';
    if ( $(this).hasClass('compare_a') ) {
      tag_num = $('.compare_b').attr('tag_num');
    } else {
      tag_num = $('.compare_a').attr('tag_num');
    }
    $('.compare_list').not($(this).siblings('.compare_list')).slideUp( 'fast', function() {

    });
    $('.compare_active_wrapper').not($(this)).removeClass('expanded');
    if ( $(this).hasClass('expanded') ) {
      $(this).siblings('.compare_list').slideUp( 'fast', function() {
		$(this).siblings('.compare_list').find('li').removeClass('hide');
      });
      $(this).removeClass('expanded');      
    } else {
      $(this).siblings('.compare_list').find('li[tag_num="' + tag_num + '"]').addClass('hide');
      $(this).siblings('.compare_list').slideDown( 600, function() {

      });
      $(this).addClass('expanded');      
    }
  
  });
  
  $('.compare_list_item').on('click', function() {
    
    var tag_num = $(this).attr('tag_num');
    var img = $(this).find('img').attr('src');
    if ( !$(this).hasClass('active') ) {
      $(this).closest('.compare_list').siblings('.compare_active_wrapper').attr('tag_num', tag_num);
      $(this).closest('.compare_list').siblings('.compare_active_wrapper').find('.compare_active').attr('src', img);
      $(this).closest('.compare_list').siblings('.compare_active_wrapper').removeClass('expanded');
      $(this).closest('.compare_list').slideUp( 'fast', function() {
		$('.compare_list_item').removeClass('hide');
      });
      $(this).siblings().removeClass('active');
      $(this).addClass('active');
      $(this).closest('.compare_menu').siblings('.compare_img_wrapper').find('.compare_img').removeClass('active');
      $(this).closest('.compare_menu').siblings('.compare_img_wrapper').find('.compare_img' + tag_num).addClass('active');
      $(this).closest('.compare_menu').siblings('.compare_content_wrapper').find('.compare_content').removeClass('active');
      $(this).closest('.compare_menu').siblings('.compare_content_wrapper').find('.compare_content' + tag_num).addClass('active');
    }
    
  });
  
  
  /* Contact form toggle function */
  $('.contact_btn').on('click', function() {
    
    if ( !$(this).hasClass('active') ) {
      var type = $(this).attr('cus_type');
      $('.contact_btn').removeClass('active');
      $(this).addClass('active');
      $('.contact_block').removeClass('active');
      $('.contact_' + type + '_form').addClass('active');
    }
    
  });
  
  
  /* Contact Page date/time function */
  $('#ContactPhoneForm-date').datepicker({
    dateFormat: "yy-mm-dd"
  });

  $('#ContactPhoneForm-time').wickedpicker();
  
  
  /* Product Block click function */
  $('.buy_block').on('click', function() {
    
    if ( !$(this).hasClass('active') ) {
    
      $(this).closest('.buy_block_wrap').find('.buy_block').removeClass('active');
      $(this).addClass('active');
      
      var ancestor = $(this).closest('.buy_block_wrap').attr('id');
      
      if ( ancestor == 'model_wrap' ) {
      
        var model = $(this).attr('model');
        $('.buy_media').addClass('hide');
        if ( model == 'ausprint-pro' ) {
          $('.buy_ausprintpro').removeClass('hide');
        } else {
          $('.buy_ausprint').removeClass('hide');
        }
        if ( $('#interface_wrap').hasClass('active') ) {
          $('#interface_wrap .buy_block_main').removeClass('active');
          $('#interface_wrap .buy_block').removeClass('active');
          $('#interface_wrap .' + model).addClass('active');
          $('#accessories').removeClass('active');
          $('#price_wrapper').removeClass('active');
          $('.multi_submit').attr('disabled', 'disabled');
        } else {
          $('#interface_wrap').addClass('active');
          $('#interface_wrap .' + model).addClass('active');
          $('#interface_wrap').slideDown(300, function() {

          });
        }
        
      } else if ( ancestor == 'label_style_wrap' ) {
        
        var label_type = $(this).attr('label_type');
        $('#blank_label_wrap .buy_block_main').removeClass('active');
        $('#blank_label_wrap .buy_block').removeClass('active');
        $('#blank_label_wrap .' + label_type + '-blank').addClass('active');
        $('#express_label_wrap .buy_block_main').removeClass('active');
        $('#express_label_wrap .buy_block').removeClass('active');
        $('#express_label_wrap .' + label_type + '-express').addClass('active');
        if ( !$('#blank_label_wrap').hasClass('active') ) {
          $('#blank_label_wrap').addClass('active');
          $('#express_label_wrap').addClass('active');
        }
        
        var initial_price = $('#price_wrapper .product__price').attr('initial_price');
        var cable_price = 0;
        if ( $('#usb_cable_wrap .buy_block.active .buy_price').length ) {
          cable_price = $('#usb_cable_wrap .buy_block.active .buy_price').attr('real_price');
        }
        var sub_price = parseFloat(initial_price) + parseFloat(cable_price);
        var sub_tax = Math.floor( sub_price * 10 ) / 100;
        $('#price_wrapper .product__price .price_right span').text(sub_price.toFixed(2));
        $('#price_wrapper .price_tax .price_right span').text(sub_tax);
        
      } else if ( ancestor == 'interface_wrap' ) {
        
        var name = $(this).find('input').attr('origin_name');
        $('#interface_wrap input').attr('name', '');
        $(this).find('input').attr('name', name);
        
        var initial_price = $(this).find('.buy_price').attr('real_price');
        $('#price_wrapper .product__price').attr('initial_price', initial_price);
        var blank_label_price = 0;
        if ( $('#blank_label_wrap .buy_block.active .buy_price').length ) {
          blank_label_price = $('#blank_label_wrap .buy_block.active .buy_price').attr('real_price');
        }
        var express_label_price = 0;
        if ( $('#express_label_wrap .buy_block.active .buy_price').length ) {
          express_label_price = $('#express_label_wrap .buy_block.active .buy_price').attr('real_price');
        }
        var cable_price = 0;
        if ( $('#usb_cable_wrap .buy_block.active .buy_price').length ) {
          cable_price = $('#usb_cable_wrap .buy_block.active .buy_price').attr('real_price');
        }
        var sub_price = parseFloat(initial_price) + parseFloat(blank_label_price) + parseFloat(express_label_price) + parseFloat(cable_price);
        var sub_tax = Math.floor( sub_price * 10 ) / 100;
        
        $('#price_wrapper .product__price .price_right span').text(sub_price.toFixed(2));
        $('#price_wrapper .price_tax .price_right span').text(sub_tax);
        
        $('#accessories').addClass('active');
        $('#price_wrapper').addClass('active');
        $('.multi_submit').removeAttr('disabled');
        
      } else {
        
        var name = $(this).find('input').attr('origin_name');
        $(this).closest('.buy_block_wrap').find('input').attr('name', '');
        $(this).find('input').attr('name', name);
        
        var initial_price = $('#price_wrapper .product__price').attr('initial_price');
        var blank_label_price = 0;
        if ( $('#blank_label_wrap .buy_block.active .buy_price').length ) {
          blank_label_price = $('#blank_label_wrap .buy_block.active .buy_price').attr('real_price');
        }
        var express_label_price = 0;
        if ( $('#express_label_wrap .buy_block.active .buy_price').length ) {
          express_label_price = $('#express_label_wrap .buy_block.active .buy_price').attr('real_price');
        }
        var cable_price = 0;
        if ( $('#usb_cable_wrap .buy_block.active .buy_price').length ) {
          cable_price = $('#usb_cable_wrap .buy_block.active .buy_price').attr('real_price');
        }
        var holder_price = 0;
        if ( $('#holder_wrap .buy_block.active .buy_price').length ) {
          holder_price = $('#holder_wrap .buy_block.active .buy_price').attr('real_price');
        }
        var sub_price = parseFloat(initial_price) + parseFloat(blank_label_price) + parseFloat(express_label_price) + parseFloat(cable_price) + parseFloat(holder_price);
        var sub_tax = Math.floor( sub_price * 10 ) / 100;
        $('#price_wrapper .product__price .price_right span').text(sub_price.toFixed(2));
        $('#price_wrapper .price_tax .price_right span').text(sub_tax);
        
      }
      
    }
    
  });
  
  
  /* Custom Modal open function */
  $('.modal_btn').on('click', function() {
    
    var modal_type = $(this).attr('modal_type');
    var img_url = $(this).attr('img_url');
    
    $('.cus_modal_inner').attr('id', modal_type);
    $('.cus_modal_left img').attr('src', img_url);
    $('.cus_modal_right').removeClass('active');
    $('.' + modal_type).addClass('active');
    $('#cus_modal').addClass('active');
    $('html').addClass('modal_on');
    
  });
  
  /* Custom Modal close function */
  $('#cus_modal_close, #cus_modal_overlay').on('click', function() {
    
    $('#cus_modal').removeClass('active');
    $('html').removeClass('modal_on');
    setTimeout(function() {
      $('.cus_modal_left img').attr('src', '');
    }, 600);    
    
  });


  /* Drivers Accordion function */
  $('.drivers_type').on('click', function() {

    if ( !$(this).hasClass('active') ) {
      let key = $(this).attr('tab_key');
      $('.drivers_type').removeClass('active');
      $(this).addClass('active');
      $('.drivers_download_innner').removeClass('active');
      $('.drivers_download_innner[tab_key="' + key + '"]').addClass('active');
      $('.drivers_sub_vidoes_innner').removeClass('active');
      $('.drivers_sub_vidoes_innner[tab_key="' + key + '"]').addClass('active');
    }
    
  });


  /* Newsletter popup toggle function */
  if ( $(window).width() > 999) {
    $('.newsletter_bar').removeClass('closed');
    $('body').addClass('newsletter_opened');
  }
  
  $('.newsletter_close').on('click', function() {
    $('.newsletter_bar').addClass('closed');
    $('body').removeClass('newsletter_opened');
  });

  $('.newsletter_open').on('click', function() {
    $('.newsletter_bar').removeClass('closed');
    $('body').addClass('newsletter_opened');
  });


  /* New PDP functions */
  $('.product_variant_group input[type="radio"]').on('change', function() {
    
    var selectedValue = $(this).val();
    $('[name="id"] option').filter(function() {
      return $(this).text() === selectedValue;
    }).prop('selected', true);
    
  });


  /* New PDP claim functions*/
  $('#product-form1, #product-form2').submit(function(e) {
    e.preventDefault();
    const productId = $(this).find('[name="product_id"]').val();

    // Use Shopify AJAX API to add the product to the cart
    $.ajax({
      type: 'POST',
      url: '/cart/add.js', // Shopify AJAX endpoint
      data: { id: productId, quantity: 1 }, // Add one quantity of the product
      dataType: 'json',
      success: function () {
        // Refresh the current page after adding the product to the cart
        window.location.reload();
      },
    });
  });
  
  function copyToClipboard( element ) {
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val(element).select();
    document.execCommand("copy");
    $temp.remove();  
  }
  
  $('#compare_step3 .claim_btn').on('click', function() {  
    var content = $(this).text();
    var element = $(this).siblings('.step_desc').find('span').text();
    copyToClipboard( element );
    $(this).text("Copied!");
    setTimeout(function() {
      $('#compare_step3 .claim_btn').text(content);
    }, 1200);  
  });

  $(document).on("submit", "form.product_multi_form", function(e){
      e.preventDefault();
      var get_model_wrap = $("#model_wrap .buy_block.active").attr("model");
      var get_interface_wrap = $("#interface_wrap .buy_block.active").find("input").val();
    
      var get_blank_label_wrap = $("#blank_label_wrap .buy_block.active").find("input").val();
      var get_blank_label_wrap_qty = $("#blank_label_wrap .buy_block.active").find("input").attr("data-vqty");    

      var get_express_label_wrap = $("#express_label_wrap .buy_block.active").find("input").val();
      var get_express_label_wrap_qty = $("#express_label_wrap .buy_block.active").find("input").attr("data-vqty");    

      var get_usb_cable_wrap = $("#usb_cable_wrap .buy_block.active").find("input").val();
      var get_holder_wrap = $("#holder_wrap .buy_block.active").find("input").val();
    
    
    
    
  //    alert('it works! = '+get_blank_label_wrap+" = "+get_blank_label_wrap_qty);    
       //var get_all_variant = $(this).attr("data-all-variant");
       var get_all_variant = "";
      if(typeof get_interface_wrap === "undefined") {
         
      }else{
        get_all_variant = get_interface_wrap+"|1";
      }

      if(typeof get_blank_label_wrap === "undefined") {
         
      }else{
        get_all_variant = get_all_variant + ","+get_blank_label_wrap+"|"+get_blank_label_wrap_qty;
      }

      if(typeof get_express_label_wrap === "undefined") {
         
      }else{
        get_all_variant = get_all_variant + ","+get_express_label_wrap+"|"+get_express_label_wrap_qty;
      }    

      if(typeof get_usb_cable_wrap === "undefined") {
         
      }else{
        get_all_variant = get_all_variant + ","+get_usb_cable_wrap+"|1";
      }        

      if(typeof get_holder_wrap === "undefined") {
         
      }else{
        get_all_variant = get_all_variant + ","+get_holder_wrap+"|1";
      }            
    
    
       //get_all_variant = get_interface_wrap+"|1,"+get_usb_cable_wrap+"|2,"+get_holder_wrap+"|3";
       addAllItems(get_all_variant);
      return  false;
  });
  
  
});

 
    function addAllItems(array){
        Shopify.queue = [];
          var quantity = 1 ;
          var newArray = array.split(',');
      
         // $(".loader_block").addClass("active_addtocart");
          for (var i = 0; i < newArray.length; i++) {
            var product_arr = newArray[i].split('|');
            var product = product_arr[0];
            var product_qty = product_arr[1];
            Shopify.queue.push({
              variantId: product,
              variantQuantity: product_qty,
            });
          }
          Shopify.moveAlong = function() {
          // If we still have requests in the queue, let's process the next one.
          if (Shopify.queue.length) {
            var request = Shopify.queue.shift();
            var data = 'id='+ request.variantId + '&quantity='+ request.variantQuantity
            $.ajax({
              type: 'POST',
                  url: '/cart/add.js',
              dataType: 'json',
              data: data,
              success: function(res){
                Shopify.moveAlong();
              quantity += 1;           
//alert("Added = "+newArray.length);
             },
                 error: function(){
                 // if it's not last one Move Along else update the cart number with the current quantity
                  if (Shopify.queue.length){
                    Shopify.moveAlong()
                  } else {
                    //$('#cart-number').replaceWith("<a href="/cart" id="cart-number">View cart (" + quantity + ")</a>")
                  }
              }
               });
            }
         // If the queue is empty, we add 1 to cart
        else {
          quantity += 1;
          //addToCartOk(quantity);
         // alert("Added");
          //$(".loader_block").removeClass("active_addtocart");
          window.location.replace('/cart');
         }
           };
        Shopify.moveAlong();
      };
    
// AllItem Add to cart Button : End           
